export default "__VITE_ASSET__CIhAtwKQ__"